// WithholdingTaxValidityCell.jsx
import React from 'react';
import { Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircleRounded';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useTranslation } from 'react-i18next';
import Styles from './ClientDataTable.module.scss';

dayjs.extend(utc);

const WithholdingTaxValidityCell = ({ client }) => {
    const { t } = useTranslation();

    const value = client.withholdingTaxApprovalValidUntil;
    if (!value) return null;

    const date = dayjs.utc(value).startOf('day');
    const today = dayjs.utc().startOf('day');
    const formatted = date.format('DD/MM/YYYY');

    const isExpired = date.isBefore(today);
    const expiresWithinMonth = !isExpired && !date.isAfter(today.add(1, 'month'));
    const statusLabel = isExpired
        ? `${t('expired')} ${formatted}`
        : expiresWithinMonth
            ? `${t('ExpiresInOneMonth')} ${formatted}`
            : formatted;
    const statusClass = isExpired
        ? Styles.dateAlert
        : expiresWithinMonth
            ? Styles.dateWarn
            : Styles.dateOk;

    return (
        <Tooltip title={statusLabel}>
            <span className={statusClass}>
                {isExpired || expiresWithinMonth ? (
                    <>
                        <WarningIcon fontSize="small" />
                        {statusLabel}
                    </>
                ) : (
                    <>
                        <CheckCircleIcon fontSize="small" />
                        {formatted}
                    </>
                )}
            </span>
        </Tooltip>
    );
};

export default WithholdingTaxValidityCell;
